import React, { useState, useEffect, useRef } from 'react';
import Lottie from 'react-lottie-player'
import { useQuery, useMutation, useQueryClient, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import api from '../api';
import successImage from '../animations/success.json';
import '../scss/main.scss';
import { CopyToClipboard } from 'react-copy-to-clipboard';

export default function Summary({ randomId, storedData, jobTitle, jobDescription, setStoredData, setStep, token }) {
	const [step, setLocalStep] = useState(storedData?.interview_id ? 'success' : null);
	const [interview_id, setInterviewId] =  useState(null);
	const [copied, setCopied] = useState(false);
	const { isLoading, isError, data, error, refetch} = useQuery(
		['saveInterview'], 
		() => api.saveInterview(jobTitle, jobDescription, storedData.selectedHardQuestions, storedData.selectedSoftQuestions, storedData.usersCanSeeAnswers, storedData.userCanVoteMultipleTimes, token), 
        {
            enabled: false,
            onSuccess: data => {
				setInterviewId(data);
				const o = {...storedData};
				o.interview_id = data;
				localStorage.setItem(randomId, JSON.stringify(o))
				setStoredData(o);
				setLocalStep('success')
            }
        }
	)
	const save = () => {
		refetch();
	}
	const goTo = (page) => {
		resetStorage();
		if(page === 'answers'){
			window.location.href = `${window.location.origin}/answers/${interview_id}`;
		}else if(page === 'create'){
			window.location.href = '/create/';
		}
	}
	const resetStorage = () => {
		const o = {
			jobTitle: null,
			jobDescription: null,
			soft: [],
			hard:[],
			selectedSoftSkills: [],
			selectedHardSkills: [],
			softQuestions: [],
			hardQuestions: [],
			selectedSoftQuestions: [],
			selectedHardQuestions: [],
			interview_id: null,
			usersCanSeeAnswers: false,
			userCanVoteMultipleTimes: false
		}
		setStoredData(o)
		localStorage.setItem(randomId, JSON.stringify(o))
	}
	useEffect(() => {
		console.log(storedData);
		if(storedData.interview_id){
			setInterviewId(storedData.interview_id);
		}
	}, [storedData])
	return (
		<div className="page">
			<div className=''>
				{step === null &&
					<div>
						<div className="flex flex__row align--center">
							<div className="btn btn__secondary" onClick={() => setStep('questions')}>
								<span className='material-icons'>
									arrow_back_ios
								</span>
								Back
							</div>
							<h3 className='text__primary text__center'>Interview Summary</h3>
						</div>
						<div className="card card__rounded">
							<h className='font2 text-[24px] mb-4 mt-8'>Hard Skills Questions</h>
							{
								storedData?.selectedHardQuestions?.map((dt, index) => (
									<div className='card card__bordered' key={`hard_question${index}`}>
										<div className="flex flex__row" style={{ alignItems: 'center' }}>
											<div className="btn btn__primary-soft btn__md">{index + 1}</div>
											<div className='font__18 text__primary'>{dt.question}</div>
										</div>
										<div className='mleft--35'>
											<b className='mr-4'>Skills To be tested: </b>
											<div className='flex flex-wrap'>
												{dt?.skills?.map((skill, index) => (
													<div className='btn btn__secondary btn__rounded btn__md capitalize' key={`hard_skill${index}`}>{skill}</div>
												))}
											</div>
										</div>
									</div>
								))
							}
						</div>
						<div className="card card__rounded">
							<h className='font2 text-[24px] mb-4 mt-8'>Soft Skills Questions</h>
							{
								storedData?.selectedSoftQuestions?.map((dt, index) => (
									<div className='card card__bordered' key={`soft_question${index}`}>
										<div className="flex flex__row" style={{alignItems: 'center'}}>
											<div className="btn btn__primary-soft btn__md">{index+1}</div>
											<div className='font__18 text__primary'>{dt.question}</div>
										</div>
										<div className='mleft--35'>
											<b className='mr-4'>Skills To be tested: </b>
											<div className='flex flex-wrap'>
												{dt?.skills?.map((skill, index) => (
													<div className='btn btn__secondary btn__rounded btn__md capitalize' key={`soft_skill${index}`}>{skill}</div>
												))}
											</div>
										</div>
									</div>
								))
							}
						</div>
						<button className='btn btn__primary btn__100 btn__rounded' onClick={save}>
							Save
						</button>
					</div>
				}
				{step === 'success' && 
					<div className="summary__success card card__rounded">
						<Lottie
							loop
							animationData={successImage}
							play
							style={{ width: 250, height: 250, margin: 'auto' }}
						/>
						<h1 className="font1">Your interview has been created and saved!</h1>
						<h4>Pick your next step</h4>
						<br />
						<div className='btn btn__primary btn__100 mtop--20' style={{cursor: 'pointer'}} onClick={() => goTo('answers')}>
							Be the first to answer
						</div>
						<CopyToClipboard text={`${window.location.origin}/answers/${data}`} onCopy={() => {
							setCopied(true)
							setTimeout(() => setCopied(false), 1500);
						}}>
							<div className='btn btn__primary-soft btn__100 mtop--20'>
								{copied ? 'Copied' : 'Copy the link and share it'}
							</div>
						</CopyToClipboard>
						<div className='btn btn__secondary-outline btn__100 mtop--20' onClick={() => goTo('create')}>
							Dashboard
						</div>
					</div>
				}
			</div>
		</div>
	)
}